import { API_endpoints } from "../config";

export const searchKids = async (searchTerm: string): Promise<any> => { 
    try {
        const response = await fetch(API_endpoints.searchKids, {
            method: 'POST',  
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ searchTerm }), 
            credentials: 'include', 
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Fehler bei der suche auf kids:", error);
        throw new Error("Fehler bei der suche auf kids.");
    }
};
